// The commercial Handsontable subscription key (EVA-233). Purchased
// 2026-07-14, covering releases up to 2027-07-14; renew it here and nowhere
// else.
//
// That date is a version-bump deadline, not a cliff. Handsontable compares the
// key against the release date its own build has baked in, never against the
// clock (`helpers/mixed.js`, `releaseDays > keyValidityDays`), so a lapsed
// subscription leaves a pinned install working indefinitely and only the next
// upgrade past the date starts printing an expiry notice into every grid.
// spec/javascript/handsontable_license_spec.rb asks the installed copy whether
// it still accepts this key, which is the question that actually matters.
//
// This is deliberately a plain committed constant rather than server config.
// Handsontable validates the key in the browser, so it ships inside every
// bundle we serve whatever its source — keeping it in `config/settings` would
// hide it from nobody and would leave dev, test and any build that missed the
// variable silently running on the evaluation key instead. It grants no access
// to anything; it is a subscription marker carrying its own expiry.
//
// Every HotTable in the app reads it from here. A literal `licenseKey` string
// anywhere under app/frontend is a licensing violation and is failed by
// spec/conventions/handsontable_license_spec.rb.
export const HOT_LICENSE_KEY = '1f90a-323c1-9fde1-64b4c-f3b42'
